import React, { useState } from "react";
import { Button } from "reactstrap";
import AddIcon from "@mui/icons-material/Add";
import DownloadIcon from "@mui/icons-material/Download";
import { fetchExportEvents } from "../../store/slices/scheduleSlice";
import { useDispatch } from "react-redux";
import { saveAs } from 'file-saver';
import { ICAL_TIMEZONES } from "../../constants";


const ScheduleHeader = ({ onCreate, generateEmbedCode }) => {
  const dispatch = useDispatch();
  const [isExporting, setIsExporting] = useState(false);

  const onExport = async () => {
    setIsExporting(true);
    try {
      let resp = await dispatch(fetchExportEvents()).unwrap();
      await exportEventsAsICalendar(resp);
    } catch (error) {
      console.error("Export failed:", error);
    } finally {
      setIsExporting(false);
    }
  }

  const extractTimezone = (rruleString) => {
    const tzidMatch = rruleString.match(/TZID=([^;:\n]*)/);
    return tzidMatch ? tzidMatch[1] : 'UTC';
  }
  
  const mapTimezoneToICal = (tzid) => {
    return ICAL_TIMEZONES[tzid] || tzid;
  }

  const updateRruleWithTimezone = (rruleString, tzid) => {
    if (rruleString.includes('TZID=')) {
      return rruleString.replace(/TZID=[^;:\n]*/, `TZID=${tzid}`);
    } else {
      return rruleString.replace('RRULE:', `RRULE;TZID=${tzid}:`);
    }
  }

  const formatEventToICal = (event) => {
    const {title, description, rrule } = event;
    const extractedTzid = extractTimezone(rrule);
    const icalTzid = mapTimezoneToICal(extractedTzid);
    const updatedRrule = updateRruleWithTimezone(rrule, icalTzid);

    return (
      `BEGIN:VEVENT\n` +
      `SUMMARY:${title}\n` +
      `DESCRIPTION:${description}\n` +
      `${updatedRrule}\n` +
      `UID:event-${event.id}\n` +
      `END:VEVENT\n`
    );
  }
  
  const exportEventsAsICalendar = events => {
    let iCalContent = `BEGIN:VCALENDAR\nVERSION:2.0\nCALSCALE:GREGORIAN\n`;

    if (Object.keys(events).length) {
      Object.values(events).forEach(event => {
        iCalContent += formatEventToICal(event);
      });
      iCalContent += 'END:VCALENDAR\n';

      const blob = new Blob([iCalContent], {
        type: 'text/calendar;charset=utf-8',
      });
      saveAs(blob, 'calendar.ics');
    }
  };

  return (
    <div className="schedule-header-actions">
      <div
        onClick={onCreate}
        className="me-2 btn btn-lg btn-primary px-2"
      >
        <AddIcon className="me-1" fontSize="small" />
        Create Event
      </div>
      <div className="d-flex align-items-center">
        <div
          onClick={!isExporting ? onExport : undefined}
          className={`btn btn-lg btn-secondary px-2 d-flex ${isExporting ? 'disabled' : ''}`}
        >
          <DownloadIcon className="me-1" fontSize="small" />
          Export iCal File
          {isExporting && (
          <div className="ms-2">
            <div className="spinner-border spinner-border-sm" role="status">
              <span className="visually-hidden">Exporting...</span>
            </div>
          </div>
        )}
        </div>
        
      </div>
      <div
        onClick={generateEmbedCode}
        className="btn btn-lg btn-secondary px-2"
      >
        Add Calendar to Your Website
      </div>
    </div>
  );
};

export default ScheduleHeader;